import { IOffer, TOfferCategory } from '../../../types/offer';

export function isSuburbanSale(offer: IOffer): boolean {
  return offer.category
    ? Array<TOfferCategory>('cottageSale', 'houseSale', 'houseShareSale', 'landSale', 'townhouseSale').includes(
        offer.category,
      )
    : false;
}
